export default __webpack_public_path__ + "static/media/axa-health-solid.4c52c159.svg";